import React , {Component,Fragment} from 'react';
import Roll from 'react-reveal/Roll';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'

export default class Contact extends Component{
    constructor(props){
        super(props);
    }
    componentDidMount(){
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
    }

    render(){
        return(
            <Fragment>
                <div className="container mt-5 mb-5">
                    <h1>Find Us</h1>
                    <div className="row w-100 p-2">
                        <div className="col-lg w-100 mb-4">
                            <Map center={[-6.147088, 106.832029]} zoom={16} className="map">
                                <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                                />
                                <Marker position={[-6.147088, 106.832029]}>
                                    <Popup>A pretty CSS3 popup.<br />Easily customizable.</Popup>
                                </Marker>
                            </Map>
                        </div>
                        <div className="col w-100">
                            <h2>Contact Information</h2>
                            <p className="mb-1">Jl. Pangeran Jayakarta No.143 L Jakarta Pusat 10730 </p>
                            <p className="mb-1">☏ +62 21 649 3347 | 649 5627</p> 
                            <p className="mb-1">🖶 +62 21 626 1076</p>
                            <p className="mb-1">sinergikaryasejahtera@gmail.com</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}


  